import React, {Component, useState, useEffect} from 'react';

import queryString from 'query-string';

import NurseryListHQ from '../Component/NurseryListHQ';

import * as Constant from '@app/Constant.js';

import axios from '@app/lib/axios';
import * as commonData from '@app/lib/common_data';

import BranchSelect from "../Component/BranchSelect";
import ContractStatSummaryHQ from "../Component/ContractStatSummaryHQ";

class List extends Component {
	constructor(props) {
		super(props);
		const query =  this.props.query;
		this.state= {
			...props,
            seasonInfo: null,
            serviceAppList: null,
            appAuthTypeList: null,
            selectedBranch: query && query.branch_id ? query.branch_id : 0,
            branchList: null,
            summaryLoadCompleted: false
		};
	}

    componentDidMount() {
        this.getBaseInfo();
    }

    getBaseInfo = () => {
        commonData.getBranchList(axios, (err, branchList) => {
            commonData.getAppAuthTypeList(axios, (err, typeList) => {
                if (!err) {
                    commonData.getServiceAppList(axios, (err, appList) => {
                        if (!err) {
                            this.setState({branchList: branchList, serviceAppList: appList, appAuthTypeList: typeList});
                            this.getContractSeasonInfo();
                        }
                    });
                } else {
                }
            });
        });
    };

    getContractSeasonInfo = () => {
        commonData.getSeasonInfo(axios, (err, result) => {
            if(!err) {
                this.setState({seasonInfo: result});
            }
        });
    };

	detailPage = (id) => {
		document.location.href = './nursery?type=view&&id=' + id;
	}

    onSelectBranch = (selectedBranch) => {
        if(selectedBranch != "branch") {
            this.setState({selectedBranch, summaryLoadCompleted: false});
        }
    }

    onSummaryLoadCompleted = (completed) => {
        this.setState({summaryLoadCompleted: completed});
    }

	render() {
		const {query, seasonInfo, branchList, serviceAppList, appAuthTypeList, selectedBranch, summaryLoadCompleted} = this.state;

        if(!serviceAppList || !appAuthTypeList || !seasonInfo) {
            return <></>;
        }

		return (
			<div className="dashboard-wrapper">
	            <div className="dashboard-ecommerce">
                	<div className="container-fluid dashboard-content bg-white box-shadow-down pb-2">
	                	<div className="row">
	                    	<div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
	                            <div className="page-header">
	                                <h2 className="pageheader-title">계약 관리</h2>
	                            </div>
	                        </div>
	                    </div>
	                	<div className="row">
	                    	<div className="col ml-3">
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="0" checked={selectedBranch == 0} className="custom-control-input" onChange={(e) => this.onSelectBranch(e.target.value)} />
                                    <span className="custom-control-label">
                                        전체 계약 현황
                                    </span>
                                </label>
                                <label className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" name="status" value="branch" checked={selectedBranch != 0} className="custom-control-input" onChange={(e) => this.onSelectBranch(e.target.value)} />
                                    <span className="custom-control-label">
                                        지사별 계약 현황
                                    </span>
                                </label>
                                <BranchSelect
                                    branchList={branchList}
                                    branch_id={selectedBranch}
                                    className="custom-control custom-form-control custom-control-inline input-group-append"
                                    style={{ height: "auto", maxWidth: "180px" }}
                                    callback={(val) => {
                                        this.onSelectBranch(val.id);
                                    }}
                                />
	                        </div>
	                    </div>
                        {
                            seasonInfo && serviceAppList && appAuthTypeList && (
                                <>
                                    <ContractStatSummaryHQ
                                        selectedBranch={selectedBranch}
                                        year={seasonInfo ? seasonInfo.recontractYear : null}                            
                                        serviceAppList={serviceAppList}
                                        appAuthTypeList={appAuthTypeList}
                                        onLoadCompleted={(completed) => {
                                            this.onSummaryLoadCompleted(completed);
                                        }}
                                    />
                                    <NurseryListHQ branch_id={0} query={query} branchList={branchList} selectedBranch={selectedBranch}
                                        seasonInfo={seasonInfo} serviceAppList={serviceAppList} appAuthTypeList={appAuthTypeList} detailFunc={this.detailPage}
                                        summaryLoadCompleted={summaryLoadCompleted} />
                                </>
                            )
                        }
	                </div>
	            </div>
	        </div>
		);
	}
}

export default List;